/**
 * Input — atom (CES standard)
 * Replicates the client portal's Input: bordered, rounded, orange focus
 * ring. forwardRef so forms and labels can attach directly.
 */

import { forwardRef, type InputHTMLAttributes } from 'react';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className = '', ...props }, ref) {
    return (
      <input
        ref={ref}
        className={`border border-gray-300 rounded px-3 py-2 bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 ${className}`}
        {...props}
      />
    );
  },
);
